// src/api/userService.ts
import apiClient from './apiClient';
import { User, UpdateProfilePayload, UpdatePreferencesPayload } from '../types';

/**
 * Fetches the detailed information for the currently authenticated user.
 */
export const getUserInfo = (): Promise<User> => {
    // The backend should identify the user via the JWT.
    // A 'userId' param might be redundant if the endpoint is protected.
    return apiClient.get('/api/user/info');
};

/**
 * Updates the user's public profile information (e.g., name, avatar URL).
 * This is used for updating the name or setting a pre-defined avatar URL (from Illustrations).
 */
export const updateUserProfile = (payload: UpdateProfilePayload): Promise<User> => {
    return apiClient.post('/api/user/profile', payload);
};

/**
 * Updates the user's application preferences (e.g., theme, language).
 */
export const updateUserPreferences = (payload: UpdatePreferencesPayload): Promise<User> => {
    return apiClient.post('/api/user/preferences', payload);
};

/**
 * Uploads a new custom avatar image file.
 * The backend will process, save to R2, and update the user's avatarUrl.
 * @param payload - FormData containing the cropped image file.
 */
export const uploadUserAvatar = (payload: FormData): Promise<User> => {
    return apiClient.post('/api/user/avatar', payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

/**
 * Removes the user's custom avatar and reverts to the default.
 * The backend will delete the file from R2 if applicable.
 */
export const removeUserAvatar = (): Promise<User> => {
    return apiClient.delete('/api/user/avatar');
};


// --- RESERVED FOR FUTURE USE ---
/**
 * (Reserved) Initiates a request to export user data.
 */
// export const requestDataExport = (): Promise<any> => {
//   return apiClient.post('/api/user/data-export');
// };

/**
 * (Reserved) Initiates a request to delete the user's account.
 */
// export const deleteAccount = (password: string): Promise<any> => {
//   return apiClient.post('/api/user/delete-account', { password });
// };